import { useState, useContext } from "react";
import AuthContext from "../../../contexts/auth";
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import * as MdIcons from 'react-icons/md';
import Spinner from "../../../components/Spinner";
import Swal from 'sweetalert2';
 
const FormForgotPwd = ({ setForgotPwdSuccess }) => {
    const userContext = useContext(AuthContext);
    const { register, handleSubmit, reset, setError, errors } = useForm();
    const [isLoading, setIsLoading] = useState(null);
 
    const onSubmit = async (data) => {
        try {
            if (data.email.includes('@') && data.email.includes('.')) {
                setIsLoading(true);
                const result = await userContext.resetPwdClient(data);
                
                setIsLoading(false);
 
                  if (result.code === 200) {
                        setIsLoading(false);
                        Swal.fire({
                          title: 'Correo enviado!',
                          text: 'Se ha enviado un correo electrónico con los pasos a seguir para modificar tu contraseña',
                          icon: 'success',
                          confirmButtonText: 'Aceptar',
                          customClass: {
                            confirmButton: 'custom-confirm-button',
                          },
                        }).then(() => {
                        
                          Swal.fire({
                            text: 'Redirigiendo al login para iniciar sesión...',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            willOpen: () => {
                              Swal.showLoading();
                            }
                          });
                          setTimeout(() => {
                            setForgotPwdSuccess(true);
                            Swal.close();
                          }, 3000);
                        });
                      }
                      else {
                        setIsLoading(false);                     
                        switch (result.code) {
                          case 404:
                            Swal.fire({
                              icon: "error",
                              title: "Correo no registrado",
                              text: "El correo electrónico no se encuentra registrado en el sistema",
                              confirmButtonText: "Ok",
                              confirmButtonColor: "#000000",
                            });
                            break;
                          default:
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: 'Ocurrio un error inesperado',
                              confirmButtonText: "Ok",
                              confirmButtonColor: "#000000",
                            });
                            break;
                        }
                      }
            }
        } catch (error) {
            console.log(error);
        }
    }
 
    return (
        <form className="text-center" onSubmit={handleSubmit(onSubmit)}>
            <h5 className="mb-2">Recuperar Contraseña</h5>
            <p className="mb-4">Por favor introduce la dirección de Correo Electronico de tu usuario. Procederemos a enviarte un correo electrónico con los pasos a seguir para modificar tu contraseña</p>
            <div className="form-group text-left px-3 mb-4">
                <label htmlFor="inputEmail" className="mb-1"><span className="text-danger">*</span> Correo electrónico</label>
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="inputEmail">
                            <MdIcons.MdEmail size={18} className="text-dark"/>
                        </span>
                    </div>
                    <input
                    type="email"
                    className={ "form-control form-control-md" + (errors.email ? " is-invalid" : "") }
                    id="inputEmail"
                    name="email"
                    required ref={register({ required: true })}/>
                    {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                </div>
            </div>
 
            <div className="form-group mt-2 mb-0">
                <button className="btn btn-blue btn-forgot rounded-pill btn-lg text-uppercase m-2" type="submit">
                    { !isLoading ? "Enviar" : <Spinner type={1} size={18} /> }
                </button>
                <Link to='/login'><button className="btn btn-outline-blue btn-forgot rounded-pill btn-lg text-uppercase m-2">Volver</button></Link>
            </div>
        </form>
    );
}
 
export default FormForgotPwd;